export const CSS = {
  container: "container",
  imageContainer: "image-container",
  closeButtonContainer: "close-button-container",
  closeButton: "close-button",
  content: "content",
  hasHeader: "has-header",
  header: "header",
  headerContent: "header-content",
  heading: "heading",
};

export const defaultPopoverPlacement = "auto";
export const ARIA_CONTROLS = "aria-controls";
export const ARIA_EXPANDED = "aria-expanded";
